import { triggerAnalyticsEvent } from 'syf-js-utilities';
const triggerChangePaymentDueDateAnalytics = (params) => triggerAnalyticsEvent({
    pageFunction: 'change due date',
    pageKind: 'account services',
    ...params
});
export default triggerChangePaymentDueDateAnalytics;
